<template>
  <div class="column full-height">
    <div class="row justify-center">
      <img
        :src="headerImg"
        alt="employment"
        class="col-xs-5 col-sm-2 col-md-1"
      />
      <p class="text-weight-medium full-width text-center q-mt-md">
        I'm employed:
      </p>
      <div class="full-width q-gutter-sm q-mt-md row justify-center">
        <SAICardToggle
          v-for="option in employmentOptions"
          :key="option.value"
          :active="user.employmentType === option.value"
          :disable="disable"
          :flat="true"
          class="row inline"
          background="grey-2"
          @click="
            $emit('update:user', { ...user, employmentType: option.value })
          "
        >
          <p class="q-py-sm q-px-md">{{ option.label }}</p>
        </SAICardToggle>
      </div>
    </div>
    <QSpace />
    <div class="row justify-center q-mt-lg full-width">
      <SAIBtn
        :disable="disable || !user.employmentType"
        :loading="loading"
        label="Next"
        icon-right="eva-arrow-forward-outline"
        :large="true"
        @click="$emit('next')"
      />
    </div>
  </div>
</template>

<script>
import { QSpace } from 'quasar';
import { SAIBtn, SAICardToggle } from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfileEmploymentType',
  props: {
    headerImg: String,
    disable: Boolean,
    loading: Boolean,
    user: {
      type: Object,
      default: () => ({})
    },
    employmentOptions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SAIBtn,
    SAICardToggle,
    QSpace
  }
};
</script>
